(function () {
  'use strict';

  var MAX_RETRIES = 10;
  var RETRY_DELAY = 300;
  var LOG_PREFIX = '[Anber quick-add hover]';
  var SECTION_KEYS = [
    'best-sellers',
    'new-arrivals',
    'for-her',
    'for-him',
    'unisex-carousel',
    'gift-carousel',
    'top-sellers'
  ];

  function log(sectionKey, message) {
    if (window.console && window.console.debug) {
      window.console.debug(LOG_PREFIX, '[' + sectionKey + ']', message);
    }
  }

  // Mueve el boton "Agregar al carrito" de cada card (que Dawn coloca
  // debajo del precio) para que quede dentro de .card__inner, asi el
  // CSS lo puede superponer sobre la imagen y mostrarlo solo al pasar
  // el raton (ver reglas [id$="__best-sellers"] .card__inner .quick-add
  // en anber-premium-tokens.css). Se usa .card__inner y no .card__media
  // a proposito: .card__media depende de quedarse position:absolute
  // (nativo de Dawn) para que la imagen rellene la card, y .card__inner
  // ya es position:relative de forma nativa y envuelve a .card__media,
  // asi que sirve igual de bien como referencia para el boton sin tocar
  // el posicionamiento de la imagen. No cambia el JS nativo de
  // quick-add (quick-add.js no depende de donde viva el nodo en el DOM).
  function moveQuickAddIntoMedia(sectionEl, sectionKey) {
    var cards = sectionEl.querySelectorAll('.card-wrapper');
    var moved = 0;

    cards.forEach(function (card) {
      var inner = card.querySelector('.card__inner');
      var quickAdd = card.querySelector('.quick-add');
      if (inner && quickAdd && quickAdd.parentElement !== inner) {
        inner.appendChild(quickAdd);
        moved++;
      }
    });

    log(sectionKey, moved + ' boton(es) de agregar al carrito movidos sobre la imagen.');
  }

  function tryInit(sectionKey, attempt) {
    var section = document.querySelector('[id$="__' + sectionKey + '"]');

    if (!section) {
      if (attempt < MAX_RETRIES) {
        window.setTimeout(function () {
          tryInit(sectionKey, attempt + 1);
        }, RETRY_DELAY);
      }
      return;
    }

    moveQuickAddIntoMedia(section, sectionKey);
  }

  function init() {
    // Solo se mueve el boton sobre la imagen en dispositivos con raton
    // real (donde el CSS lo oculta hasta el hover). En tactil/movil no
    // hay hover, asi que el boton se queda donde Dawn lo pone de forma
    // nativa (debajo del precio) en vez de tapar la imagen a la vista.
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      return;
    }

    SECTION_KEYS.forEach(function (sectionKey) {
      tryInit(sectionKey, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
